import React from "react"
import { fetchCampaign } from "../../services/dataStore"
import { filterEmptyValues } from "../../helpers/filterEmptyValues"

import {
  PROMO_CODE_COOKIE,
  COOKIE_DOMAIN,
} from "../../constants/cookies"

const Cookies = require("js-cookie")

interface DisclaimerProps extends DisclaimerState {
}

interface DisclaimerState {
  welcomeMessage?: string,
}

interface FetchDataParams {
  retry?: boolean,
  cookie?: string,
}

class DisclaimerInner extends React.Component<
DisclaimerProps,
DisclaimerState> {
  public static defaultProps = {
    welcomeMessage: "*Offer valid for 2-person plan, 3 nights per week.",
  }

  constructor(props: DisclaimerProps) {
    super(props)
    this.state = {
      welcomeMessage: "",
    }
  }

  componentDidMount() {
    const cookie = this.getCookieCode()
    this.setDefaultState()

    if (cookie) {
      this.fetchData({ cookie })
    }
  }

  private setDefaultState(): void {
    this.setState({ ...this.props })
  }

  private getCookieCode(): string {
    const cookieCode: string = Cookies.get(PROMO_CODE_COOKIE, { domain: COOKIE_DOMAIN })
    return cookieCode
  }

  private async fetchData({ cookie }: FetchDataParams) {
    try {
      const query = `
        welcomeMessage
      `
      let campaign = await fetchCampaign(query, cookie)
      campaign = filterEmptyValues(campaign)
      this.setState({ ...campaign })
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    const {
      welcomeMessage,
    } = this.state

    return (
      <div className="text-xs leading-6" role="text">{welcomeMessage}</div>
    )
  }
}

export function Disclaimer(props: DisclaimerProps) {
  return <DisclaimerInner {...props} />
}
